import React, { useContext, useEffect, useState } from 'react';

import * as S from './styles';
import { ScreenBlackFridayType } from 'types/ScreenBlackFridayType';
import SimpleInput from 'components/SimpleInput';
import TitleForm from 'components/TitleForm';
import InputImgBigger from 'components/InputImgBigger';
import { ImgSavedProps } from 'types/ImgSavedProps';
import ScreensStaticContext from 'context/ScreensStaticContext';
import CreateImgWithRedirectAndLabel from 'components/CreateImgWithRedirectAndLabel';
import { ImageInCarrosselScreens } from 'types/ImageInCarrosselScreens';
import { ItemScreenStatic } from 'types/ScreensStaticsProps';
import SystemNotifyContext from 'context/SystemNotifyContext';
import LoadGeneralContext from 'context/LoadGeneralContext';
import { editStaticScreen } from 'components/FormSreenStatics/reqs';

type BlackFridayFormProps = {
	closeModal: () => void;
};

const intialDataForm: ScreenBlackFridayType = {
	carrouselImgs: [{ id: '', urlImage: '', linkRedirect: '', labelImage: '' }],
	firstTimer: {
		title: '',
		endDate: ''
	},
	firstQueryListProductsBlackFriday: '',
	carrosselProducts: {
		title: '',
		products: [{ id: '', urlImage: '', linkRedirect: '', labelImage: '' }]
	},
	firstBigImg: { id: '', urlImage: '', linkRedirect: '', labelImage: '' },
	secondTimer: {
		title: '',
		endDate: ''
	},
	secondQueryListProductsBlackFriday: '',
	videoUrl: '',
	thirdQueryListProductsBlackFriday: {
		title: '',
		query: ''
	}
};

export default function BlackFridayForm({ closeModal }: BlackFridayFormProps) {
	const { screens, setScreens } = useContext(ScreensStaticContext);
	const { handleNotify } = useContext(SystemNotifyContext);
	const { setMessage, setIsOpenLoad } = useContext(LoadGeneralContext);

	const [dataForm, setDataForm] = useState(intialDataForm);

	async function saveData() {
		let screenToEdit: ItemScreenStatic = { type: 'blackFriday', data: null };

		const newScreens = screens.map((value) => {
			if (value.type === 'blackFriday') {
				value.data = dataForm;
				screenToEdit = {
					...screenToEdit,
					data: dataForm,
					id: value?.id || '0'
				};
			}

			return value;
		});

		setIsOpenLoad(true);
		setMessage('Salvando dados');
		const isSuccess = await editStaticScreen(screenToEdit, handleNotify);
		setIsOpenLoad(false);

		if (isSuccess) {
			setScreens(newScreens);
			closeModal();
		}
	}

	useEffect(() => {
		const blackfridayScreen = screens.find(
			(screen) => screen.type === 'blackFriday'
		);

		if (blackfridayScreen) {
			setDataForm(blackfridayScreen.data as ScreenBlackFridayType);
		}
	}, []);

	return (
		<S.container>
			<S.box>
				<S.forms>
					<TitleForm title="Carrossel de imagens">
						<CreateImgWithRedirectAndLabel
							imgs={dataForm.carrouselImgs}
							textBtn="Adicionar imagem"
							getImgs={(imgs: ImageInCarrosselScreens[]) => {
								setDataForm((obj) => ({
									...obj,
									carrouselImgs: imgs
								}));
							}}
						/>
					</TitleForm>

					<TitleForm title="Primeiro timer">
						<S.twoInputsRow>
							<SimpleInput
								label="Título timer"
								initialValue={dataForm.firstTimer.title}
								getValue={(value: string) => {
									setDataForm((obj) => ({
										...obj,
										firstTimer: { ...obj.firstTimer, title: value }
									}));
								}}
							/>

							<SimpleInput
								paddingInLineEnd
								label="Data de finalização"
								typeInput="datetime-local"
								initialValue={dataForm.firstTimer.endDate}
								getValue={(value: string) => {
									setDataForm((obj) => ({
										...obj,
										firstTimer: { ...obj.firstTimer, endDate: value }
									}));
								}}
							/>
						</S.twoInputsRow>{' '}
					</TitleForm>

					<TitleForm title="Primeiro carrossel de produtos">
						<SimpleInput
							label="Query"
							initialValue={dataForm.firstQueryListProductsBlackFriday}
							getValue={(value: string) => {
								setDataForm((obj) => ({
									...obj,
									firstQueryListProductsBlackFriday: value
								}));
							}}
						/>
					</TitleForm>

					<TitleForm title="Carrossel de ofertas">
						<CreateImgWithRedirectAndLabel
							imgs={dataForm.carrosselProducts.products}
							textBtn="Adicionar oferta"
							getImgs={(imgs: ImageInCarrosselScreens[]) => {
								setDataForm((obj) => ({
									...obj,
									carrosselProducts: {
										...obj.carrosselProducts,
										products: imgs
									}
								}));
							}}
						/>
					</TitleForm>

					<TitleForm title="Primeira imagem">
						<S.twoInputsColumn>
							<InputImgBigger
								idImagem="lastImg"
								label="Imagem grande"
								getImage={(value: ImgSavedProps) => {
									setDataForm((obj) => ({
										...obj,
										firstBigImg: {
											...obj.firstBigImg,
											urlImage: value?.url || ''
										}
									}));
								}}
								initialImage={dataForm.firstBigImg.urlImage}
							/>
							<SimpleInput
								label="Redirect"
								initialValue={dataForm.firstBigImg.linkRedirect}
								getValue={(value: string) => {
									setDataForm((obj) => ({
										...obj,
										firstBigImg: { ...obj.firstBigImg, linkRedirect: value }
									}));
								}}
							/>
						</S.twoInputsColumn>
					</TitleForm>

					<TitleForm title="Segundo timer">
						<S.twoInputsRow>
							<SimpleInput
								label="Título timer"
								initialValue={dataForm.secondTimer.title}
								getValue={(value: string) => {
									setDataForm((obj) => ({
										...obj,
										secondTimer: { ...obj.secondTimer, title: value }
									}));
								}}
							/>

							<SimpleInput
								paddingInLineEnd
								label="Data de finalização"
								typeInput="datetime-local"
								initialValue={dataForm.secondTimer.endDate}
								getValue={(value: string) => {
									setDataForm((obj) => ({
										...obj,
										secondTimer: { ...obj.secondTimer, endDate: value }
									}));
								}}
							/>
						</S.twoInputsRow>
					</TitleForm>

					<TitleForm title="Segundo carrossel de produtos">
						<SimpleInput
							label="Query"
							initialValue={dataForm.secondQueryListProductsBlackFriday}
							getValue={(value: string) => {
								setDataForm((obj) => ({
									...obj,
									secondQueryListProductsBlackFriday: value
								}));
							}}
						/>
					</TitleForm>

					<TitleForm title="Video">
						<SimpleInput
							label="Url do video"
							initialValue={dataForm.videoUrl}
							getValue={(value: string) => {
								setDataForm((obj) => ({
									...obj,
									videoUrl: value
								}));
							}}
						/>
					</TitleForm>

					<TitleForm title="Terceiro carrossel de produtos">
						<S.twoInputsRow>
							<SimpleInput
								label="Título carrossel"
								initialValue={dataForm.thirdQueryListProductsBlackFriday.title}
								getValue={(value: string) => {
									setDataForm((obj) => ({
										...obj,
										thirdQueryListProductsBlackFriday: {
											...obj.thirdQueryListProductsBlackFriday,
											title: value
										}
									}));
								}}
							/>

							<SimpleInput
								paddingInLineEnd
								label="Query"
								initialValue={dataForm.thirdQueryListProductsBlackFriday.query}
								getValue={(value: string) => {
									setDataForm((obj) => ({
										...obj,
										thirdQueryListProductsBlackFriday: {
											...obj.thirdQueryListProductsBlackFriday,
											query: value
										}
									}));
								}}
							/>
						</S.twoInputsRow>
					</TitleForm>
				</S.forms>
			</S.box>
			<S.containerBtns>
				<S.cancel
					data-testid="cancelBtn"
					onClick={() => {
						closeModal();
					}}
				>
					Cancelar
				</S.cancel>
				<S.save
					data-testid="saveBtn"
					onClick={() => {
						closeModal();
						saveData();
					}}
				>
					Salvar
				</S.save>
			</S.containerBtns>
		</S.container>
	);
}
